import StoresRoot from './Stores';

const StoresList = () => import(/* webpackChunkName: "collections" */ './StoresList');
const StoreCreateUpdate = () => import(/* webpackChunkName: "collections" */ './StoreCreateUpdate');

export default {
  path: '/collections',
  name: 'stores',
  component: StoresRoot,
  redirect: '/collections/all',
  children: [{
    path: 'all',
    name: 'storesAll',
    component: StoresList,
  }, {
    path: ':storeId/edit',
    name: 'storesEdit',
    component: StoreCreateUpdate,
    props: true
  }, {
    path: 'create',
    name: 'storesCreate',
    component: StoreCreateUpdate,
  }],
};